import { render, staticRenderFns } from "./AlterarSenhaExterno.vue?vue&type=template&id=964df0a0&"
import script from "./AlterarSenhaExterno.vue?vue&type=script&lang=js&"
export * from "./AlterarSenhaExterno.vue?vue&type=script&lang=js&"
import style0 from "./AlterarSenhaExterno.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports